<template>
    <div class="height-full">
        <div class="width-full height-full" v-if="['AssessmentStartPage', 'AssessmentStartListPage', 'ChooseMainSymptomPage', 'SymptomsQuestionsPage', 'AssessmentSymptomsPriorityListPage'].indexOf($route.name) > -1">
            <!--Alerts [ICON_ALERT_INFORMATION]-->
            <info-icon-svg></info-icon-svg>
        </div>
    </div>
</template>

<!-- ################################################################## -->

<script>
    import {mapActions, mapGetters} from 'vuex';
    import infoIconSvg from "../svg/topBarAlerts/infoIcon";

    export default {
        name: 'AssessmentAlerts',
        components: {
            infoIconSvg
        },
        computed: {
            ...mapGetters({
                medicalStatuses: 'AssessmentAlertsStore/getMedicalStatuses',
                medicalStatus: 'AssessmentAlertsStore/getMedicalStatus',
                assessmentStatus: 'AssessmentAlertsStore/getAssessmentStatus'
            })
        },

        methods: {
            ...mapActions({
                showScoringPopup: 'AssessmentAlertsStore/showScoringPopup'
            })
        }
    }
</script>

<!-- ################################################################## -->

<style lang="scss" scoped>

    .alerts-top img {
        position: relative;
        bottom: 10px;
    }

    /*.alerts-icon {*/
    /*    position: relative;*/
    /*    bottom: 10px;*/
    /*    cursor: pointer;*/
    /*}*/

   /* .assessment-alerts {
        position: relative;
        right: -8px;
    }*/

</style>



// WEBPACK FOOTER //
// src/common/components/shared/AssessmentAlerts.vue